import { useTranslations } from "@jugl-web/utils";
import React, { useMemo, useRef } from "react";
import { AutomationVariablesPopover } from "../../../AutomationVariablesPopover";
import { AutomationVariableDefinition } from "../../../../types";
import { mapVariablesToAutomationListItems } from "../../../../utils";
import {
  VariableTokenInput,
  VariableTokenInputHandle,
} from "../../../../../VariableTokenInput";
import type { RequestRow } from "../../types";

type RequestRowValueRichFieldProps = {
  row: RequestRow;
  onChange: (next: RequestRow) => void;
  supportedVariables: AutomationVariableDefinition[];
};

export const RequestRowValueRichField: React.FC<
  RequestRowValueRichFieldProps
> = ({ row, onChange, supportedVariables }) => {
  const { t } = useTranslations();
  const inputRef = useRef<VariableTokenInputHandle>(null);

  const listItems = useMemo(
    () => mapVariablesToAutomationListItems(supportedVariables),
    [supportedVariables]
  );

  return (
    <div className="border-grey-400 relative box-border flex h-14 w-full items-center gap-2 overflow-hidden rounded-[10px] border border-solid pl-5 pr-3 transition-colors focus-within:border-[#90C9F9] focus-within:ring-2 focus-within:ring-[#90C9F9]">
      <VariableTokenInput
        ref={inputRef}
        value={row.value}
        onChange={(value) => onChange({ ...row, value })}
        placeholder={t({ id: "common.enter", defaultMessage: "Enter" })}
        className="min-w-0 flex-1"
        inputClassName="w-full bg-transparent border-none p-0 text-base leading-4"
      />
      <div className="shrink-0">
        <AutomationVariablesPopover
          listItems={listItems}
          onInsert={(id) => inputRef.current?.insertAtCursor(`{${id}}`)}
          triggerVariant="iconOnly"
        />
      </div>
    </div>
  );
};
